import React from 'react';
import FormInput from '../../../../../common/FormInput';
import {t} from '../../../../../../services/i18n';
import useHokEditedPricePerSession from '../../../../../../Hooks/useHokEditedPricePerSession';

const HokPricePerSessionInput = (props) => {
    const {price, daysOfWeek, editedValue, fieldPath, setFieldValue, error, currencySymbol, enabled} = props;
    const {displayedPricePerSession} = useHokEditedPricePerSession({
        price,
        daysOfWeek,
        editedValue,
        fieldPath,
        setFieldValue,
        enabled,
    });

    if (!enabled) return null;

    return (
        <FormInput
            value={displayedPricePerSession}
            onChangeCallback={(val) => setFieldValue(fieldPath, val === '' || val === null ? null : val)}
            label={t('hugim-price-per-session')}
            infoTooltip={t('hugim-price-per-session-tooltip')}
            width={'fit-content'}
            inputWidth={'6rem'}
            formatAddon={currencySymbol}
            inputType={'float'}
            error={error}
            containerProps={{mb: 0}}
            errorHeight={'unset'}
            labelProps={{mediumFont: false}}
        />
    );
};

export default HokPricePerSessionInput;
